import { useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { FolderDialog } from "@/components/sources/FolderBrowser";

export const FolderFilter = ({ section, folders = [], onChange, busy }) => {
  const [open, setOpen] = useState(false);
  const save = (next) => onChange(section.key, next);
  const load = (parent) => api.get("/plex/folders", { params: { section: section.key, parent } }).then((r) => r.data);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`plex-folder-filter-${section.key}`}>
      <span className="w-28 truncate text-sm text-zinc-700">{section.title}</span>
      {!folders.length && <span className="font-mono text-[11px] text-zinc-400">whole library</span>}
      {folders.map((f) => (
        <span key={f} className="flex items-center gap-1 rounded-full bg-amber-50 px-3 py-1 font-mono text-[11px] text-amber-800" data-testid={`plex-folder-chip-${section.key}`}>
          /{f}<button onClick={() => save(folders.filter((x) => x !== f))} disabled={busy} aria-label="Remove folder" className="ml-1 hover:text-amber-950"><X size={11} /></button>
        </span>
      ))}
      <button onClick={() => setOpen(true)} disabled={busy} className="text-xs text-zinc-500 underline-offset-2 hover:text-zinc-900 hover:underline" data-testid={`plex-folder-choose-${section.key}`}>
        {folders.length ? "Add folder" : "Choose folder"}
      </button>
      <FolderDialog open={open} onOpenChange={setOpen} testid="plex-folder-dialog" rootLabel={section.title} load={load}
        title="Import from one folder" description={`Only videos inside this folder (and its sub-folders) of “${section.title}” will be imported.`}
        onPick={({ path }) => save([...new Set([...folders, path])])} />
    </div>
  );
};
